'use client'

import { Switch as SwitchPrimitive } from '@base-ui/react/switch'
import { cn } from '@nt/ui/cn'
import { switchRecipe } from '@nt/ui/recipes'

function Switch({
  className,
  size = 'default',
  ...props
}: SwitchPrimitive.Root.Props & {
  size?: 'sm' | 'default'
}) {
  return (
    <SwitchPrimitive.Root data-slot="switch" data-size={size} className={cn(switchRecipe.root, className)} {...props}>
      <SwitchPrimitive.Thumb data-slot="switch-thumb" className={switchRecipe.thumb} />
    </SwitchPrimitive.Root>
  )
}

export { Switch }
